import { sliceKeys } from './constants';

const getPageState = (state) => state.roomsAcceptanceStore;
const getSliceState = (state, slice) => getPageState(state)[slice];

export const getCompanyState = (state) =>
  getSliceState(state, sliceKeys.companies);

export const getCityState = (state) => getSliceState(state, sliceKeys.cities);

export const getHouseState = (state) => getSliceState(state, sliceKeys.houses);

export const getRoomState = (state) => getSliceState(state, sliceKeys.rooms);

export const getRelatedRoomState = (state) =>
  getSliceState(state, sliceKeys.relatedRooms);

export const getDesksState = (state) => getSliceState(state, sliceKeys.desks);

export const getCreatePageState = (state) =>
  getSliceState(state, sliceKeys.createPage);

export const getRoomListViewState = (state) =>
  getSliceState(state, sliceKeys.roomListView);

export const getAttachmentsFilterState = (state) =>
  getSliceState(state, sliceKeys.attachmentsFilter);

export const hasFilter = (filter) => {
  if (filter == null) return false;

  return Object.values(filter).some((value) =>
    Array.isArray(value) ? value.length > 0 : Boolean(value)
  );
};
